import { Instance } from 'mobx-state-tree'
import { PlayerInformationModelBase } from './PlayerInformationModel.base'

/* The TypeScript type of an instance of PlayerInformationModel */
export interface PlayerInformationModelType extends Instance<typeof PlayerInformationModel.Type> {}

/* A graphql query fragment builders for PlayerInformationModel */
export {
  selectFromPlayerInformation,
  playerInformationModelPrimitives,
  PlayerInformationModelSelector
} from './PlayerInformationModel.base'

/**
 * PlayerInformationModel
 */
export const PlayerInformationModel = PlayerInformationModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
